"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var LockIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M16.5598 10.6275H17.4233L17.4234 10.6277C17.7553 10.6277 18.0211 10.8905 17.9987 11.2199L17.9981 19.0077C17.9981 19.3366 17.7322 19.6 17.4004 19.6H6.5977C6.26585 19.6 6 19.3366 6 19.0077V11.2422C6 10.9134 6.26585 10.6499 6.5977 10.6499H7.46125C7.59448 10.6499 7.68289 10.5401 7.68289 10.4303V8.3024C7.68289 5.8673 9.71935 3.91523 12.1768 4.00284C14.5226 4.09034 16.3382 6.06457 16.3382 8.3899V10.4079C16.3382 10.5399 16.449 10.6275 16.5598 10.6275ZM12.1767 5.34083C10.4502 5.25317 9.03314 6.61303 9.03314 8.30218L9.01079 8.30219V10.4295C9.01079 10.5615 9.12161 10.6491 9.23243 10.6491L14.8109 10.6497C14.9442 10.6497 15.0326 10.5399 15.0326 10.4301V8.38983C15.0326 6.78881 13.793 5.42844 12.1767 5.34083Z" }))); };
exports.LockIcon = LockIcon;
